import React from 'react';
import PujaCard from '../components/PujaCard';
import { translations } from '../mock';
import { useLang } from '../context/LanguageContext';
import { useData } from '../context/DataContext';

export default function AllPujas() {
  const { t, lang } = useLang();
  const { pujas } = useData();
  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <div className="section-heading">
        <span className="text-3xl md:text-4xl font-bold gradient-text">{t(translations.sections.upcoming)}</span>
      </div>
      <p className="text-center text-stone-600 -mt-6 mb-10">
        {lang === 'en' ? 'Browse all sacred pujas across Bharat' : 'भारत भर की सभी पवित्र पूजाएं देखें'}
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {pujas.map((p) => (
          <PujaCard key={p.id} puja={p} />
        ))}
      </div>
    </div>
  );
}
